export const imageData = [
  { url: '/images/Senior_Guidance_Talk.jpg', text: `Senior Guidance Talk Session`, date: "Date: May '24" },
  { url: '/images/Linkedlist_Practice.jpg', text: `Linked-List Practice Session`, date: "Date: March '24" },
  { url: '/images/Coding_Contest.jpg', text: `Coding Contest-1`, date: "Date: January '24" },
  { url: '/images/Coding_Contest_1_winner.jpg', text: `Coding Contest-1 Winner`, date: "Date: January '24" }
];
